import { Role } from "@resamare/models";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";

export type ProtectedRouteOptions = {
    loginUrl: string;
    unauthorizedUrl: string;
};

const defaultOptions: ProtectedRouteOptions = {
    loginUrl: "/auth/login",
    unauthorizedUrl: "/unauthorized",
};

export type ProtectedRouteProps = {
    allowedRole: Role;
    options?: Partial<ProtectedRouteOptions>;
};

export function ProtectedRoute({ allowedRole, options = {} }: ProtectedRouteProps) {
    const { admin, role } = useAuth();
    const location = useLocation();

    const mergedOptions: ProtectedRouteOptions = { ...defaultOptions, ...options };

    if (!admin) {
        return <Navigate replace state={{ from: location }} to={mergedOptions.loginUrl} />;
    }

    if (role !== allowedRole) {
        return <Navigate replace state={{ from: location }} to={mergedOptions.unauthorizedUrl} />;
    }

    return <Outlet />;
}
